module.exports = __webpack_public_path__ + "static/group4_3-7753fb207a9aec829507aea852ded5cd.webp";